import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import EvenementSearch from '../components/EvenementSearch.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        const blogApp = createApp({
            template: '<EvenementSearch />',
            components: {
                EvenementSearch
            },
            data() {
                return {
                }
            },
            mounted() {
            },
        })
        blogApp.mount(self.el)
    }
}
